<template>
  <Timeline :style="{backgroundColor: '#fff'}">
    <TimelineItem :style="{padding: '15px'}" :color="item.color" v-for="item in logs_own" :key="item.id">
      <p class="time">{{ item.unlock_time_format }}</p>
      <p class="content"><b>解锁：</b>
        <span v-if="item.is_success" :style="{color: 'green'}">成功</span>
        <span v-if="!item.is_success" :style="{color: 'red'}">失败</span>
      </p>
      <p><b>操作人：</b>{{ item.user_full_name }}</p>
    </TimelineItem>
  </Timeline>
</template>
<script>
export default {
  name: 'unlockLogs',
  props: ['logs'],
  data () {
    return {
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
<style>
  .time{
    font-size: 14px;
    font-weight: bold;
  }
  .ivu-timeline-item-tail {
    border-left: 0 !important;
  }
</style>
